import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-app-register',
  templateUrl: './app-register.component.html',
  styleUrls: ['./app-register.component.css']
})
export class AppRegisterComponent implements OnInit {
  accId: any;
  appType_list: any = [
    {
      "displayName": "Custom App",
      "value": "CUSTOM_APP"
    },
    {
      "displayName": "Business App",
      "value": "SP_APP"
    }]
    deviceType_list: any = [
      {
        "displayName": "Android",
        "value": "ANDROID"
      },
      {
        "displayName": "IOS",
        "value": "IOS"
      }]
      public appForm: UntypedFormGroup;
      btndisabled = false;
      api_error: string;
  api_success: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: number, private matDialog: MatDialogRef<any>,private formbuilder: UntypedFormBuilder,private accountService: AccountService) { }

  ngOnInit(): void {
    this.createForm();
    this.accId = this.data['accountId'];
  }
  createForm() {
    console.log(this.appType_list)
    this.appForm = this.formbuilder.group({
      appType: ['CUSTOM_APP'],
      deviceType: ['ANDROID'],
      appPackageId: [],
      project: []
    });
  }
  limitCharactersId(event: any) {
    const input = event.target;
    const value = input.value;

    if (value.length > 100) {
      input.value = value.slice(0, 100);
      this.appForm.controls['appPackageId'].setValue(value.slice(0, 100));
    }
  }
  limitCharactersProject(event: any) {
    const input = event.target;
    const value = input.value;

    if (value.length > 100) {
      input.value = value.slice(0, 100);
      this.appForm.controls['project'].setValue(value.slice(0, 100));
    }
  }
  Submit() {
    this.btndisabled = false;
      const postdata = {
        appType: this.appForm.get('appType').value,
        deviceType: this.appForm.get('deviceType').value,
        appPackageId: this.appForm.get('appPackageId').value,
        project: this.appForm.get('project').value,

      };
      this.btndisabled = true;
      this.api_error = '';
      this.accountService.registerApp(this.accId, postdata)
        .subscribe(res => {
          this.api_success = 'Registration successfully';
          setTimeout(() => {
            this.matDialog.close();
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.btndisabled = false;
          });
    }
  
}
